import { useEffect } from 'react';
export var useClickOutside = function (ref, callback, ignoreDataAttributes) {
    useEffect(function () {
        var handleClick = function (e) {
            if (ref.current && !ref.current.contains(e.target)) {
                var target_1 = e.target;
                if (ignoreDataAttributes === null || ignoreDataAttributes === void 0 ? void 0 : ignoreDataAttributes.length) {
                    var isInsideIgnoredElement = ignoreDataAttributes.some(function (attr) { return !!target_1.closest("[".concat(attr, "]")); });
                    if (isInsideIgnoredElement) {
                        return;
                    }
                }
                callback();
            }
        };
        document.addEventListener('mousedown', handleClick);
        return function () {
            document.removeEventListener('mousedown', handleClick);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [callback, ref]);
};
